import type { AppConfig } from "./AppConfig";

/**
 * Единственное место, где клиентский код читает переменные окружения сборки:
 * дальше по дереву значения ходят только как AppConfig.
 */
export function readAppConfig(): AppConfig {
  const faroUrl: unknown = import.meta.env.VITE_FARO_URL;
  const appVersion: unknown = import.meta.env.VITE_APP_VERSION;
  if (typeof appVersion !== "string" || appVersion === "") {
    throw new Error("VITE_APP_VERSION is not set for this build");
  }
  const collectorUrl = typeof faroUrl === "string" && faroUrl !== "" ? faroUrl : null;
  return {
    appVersion,
    environment: import.meta.env.MODE,
    faroUrl: collectorUrl,
  };
}
